const openCartAfterAdd = () => {
  requestAnimationFrame(() => {
    const cartLink = document.querySelector(
      'header a[href="/cart"], header a[href$="/cart"]'
    );
    if (cartLink) cartLink.click();
  });
};

document.body.addEventListener('switch:cart:afteradditem', openCartAfterAdd);

// Flash Cart appends a new size-selection riser whenever its recommendations
// refresh, but older copies can remain in the document. Remove stale copies
// before the app binds the current recommendation buttons.
document.addEventListener('obsidian:upsell:upsells:updated', () => {
  const currentRisers = new Map();

  document.querySelectorAll('[data-riser^="quick-add-"]').forEach((riser) => {
    const key = riser.dataset.riser;
    const staleRiser = currentRisers.get(key);

    if (staleRiser) staleRiser.remove();
    currentRisers.set(key, riser);
  });
});

document.addEventListener('alpine:init', () => {
  Alpine.data('QuickAdd', (variantsJson) => {
    return {
      variants: [],
      sizes: [],
      selectedVariantId: null,
      loading: false,
      added: false,
      choosingSize: false,
      error: null,
      allSoldOut: false,
      hasMultipleSizes: false,

      init() {
        const embeddedVariants = this.$el.querySelector(
          '[data-quick-add-variants]'
        )?.textContent;

        try {
          this.variants = Array.isArray(variantsJson)
            ? variantsJson
            : JSON.parse(embeddedVariants || '[]');
        } catch (error) {
          this.variants = [];
        }

        // Build size list from variants
        const sizeMap = new Map();
        this.variants.forEach((v) => {
          const size = v.option1;
          if (size && !sizeMap.has(size)) {
            sizeMap.set(size, {
              value: size,
              available: v.available,
              variantId: v.id,
            });
          }
        });
        this.sizes = Array.from(sizeMap.values());

        this.allSoldOut = this.variants.every((v) => !v.available);
        this.hasMultipleSizes = this.sizes.length > 1;

        // Auto-select if only one variant
        if (this.variants.length === 1) {
          this.selectedVariantId = this.variants[0].id;
        }
      },

      handleButtonClick() {
        if (this.loading || this.allSoldOut || !this.selectedVariantId) return;
        this.addToCart(this.selectedVariantId);
      },

      handleMobileAddClick() {
        if (this.loading || this.allSoldOut) return;

        if (this.hasMultipleSizes) {
          this.choosingSize = true;
          return;
        }

        this.handleButtonClick();
      },

      closeSizeSheet() {
        if (!this.choosingSize) return;
        this.choosingSize = false;
        this.$nextTick(() => this.$refs.trigger?.focus());
      },

      handleSizeClick(size) {
        if (this.loading || !size.available) return;
        const variant = this.variants.find((v) => v.option1 === size.value);
        if (variant) {
          this.addToCart(variant.id);
        }
      },

      async addToCart(variantId) {
        this.loading = true;
        this.error = null;

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        formData.append(
          'sections',
          'drawer-cart-items,drawer-cart-footer,cart-item-count'
        );
        formData.append('sections_url', window.location.pathname);

        try {
          const res = await fetch(window.theme.routes.cart_add_url, {
            method: 'POST',
            credentials: 'same-origin',
            body: formData,
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'application/javascript',
            },
          });

          const data = await res.json();

          if (!res.ok || (typeof data.status === 'number' && data.status >= 400)) {
            this.error = data.description || data.message || 'Error';
            this.loading = false;
            return;
          }

          this.loading = false;
          this.added = true;
          this.choosingSize = false;

          document.body.dispatchEvent(
            new CustomEvent('switch:cart:afteradditem', {
              bubbles: true,
              detail: { response: data },
            })
          );

          // Trigger Flash Cart (Obsidian) notification
          document.dispatchEvent(new Event('obsidian:upsell:update'));
          document.dispatchEvent(new Event('obsidian:upsell:refresh'));

          setTimeout(() => {
            this.added = false;
          }, 2000);
        } catch (err) {
          this.loading = false;
          this.error = 'Error';
          setTimeout(() => {
            this.error = null;
          }, 2000);
        }
      },

      get buttonText() {
        if (this.loading) return '';
        if (this.added) return '\u2713 Added';
        if (this.allSoldOut) return 'Sold Out';
        return 'Add to Cart';
      },

      get mobileButtonText() {
        if (this.loading) return '';
        if (this.added) return 'Added';
        if (this.allSoldOut) return 'Sold Out';
        return 'Add';
      },
    };
  });
});
